module.exports = __webpack_public_path__ + "static/media/actions.f53e6fe0.svg";